import { render, staticRenderFns } from "./converConf.vue?vue&type=template&id=0bce7870&scoped=true&"
import script from "./converConf.vue?vue&type=script&lang=js&"
export * from "./converConf.vue?vue&type=script&lang=js&"
import style0 from "./converConf.vue?vue&type=style&index=0&id=0bce7870&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce7870",
  null
  
)

export default component.exports